<template>
  <Modal v-model="model" :title="title" :width="width" :mask-closable="false" @on-visible-change="bindGetData">
    <Form v-if="type === 'budget'" inline :label-width="80" @submit.native.prevent>
      <FormItem label="预算">
        <InputNumber v-model="current" placeholder="请输入预算金额" style="width: 250px" />
      </FormItem>
    </Form>
    <Form v-else-if="type === 'bid' && data" inline :label-width="140" @submit.native.prevent>
      <FormItem label="目标出价" v-if="isShowBid">
        <input-number-plus
          :max="5"
          :min="0.1"
          :step="0.1"
          :maxNum="10000"
          :precision="2"
          v-model="data.cpa_bid"
          placeholder="预算不少于0.1元，不超过10000元"
          :width="300"
        />
        <span style="padding-left: 8px">元</span>
      </FormItem>
      <FormItem label="深度优化方式">
        <RadioGroup v-model="data.deep_bid_type" type="button" @on-change="changeDeepBid">
          <Radio label="">无深度优化</Radio>
          <Radio :disabled="$parent.appPromotionType === 'RESERVE'" label="DEEP_BID_MIN">自定义双出价</Radio>
          <Radio :disabled="$parent.appPromotionType === 'RESERVE'" label="ROI_COEFFICIENT">ROI系数</Radio>
          <Radio :disabled="$parent.appPromotionType === 'RESERVE'" label="BID_PER_ACTION">每次付费</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="ROI系数" v-if="data.deep_bid_type === 'ROI_COEFFICIENT' && isShowBid">
        <input-number-plus
          v-model="data.roi_goal"
          :max="1"
          :maxNum="5"
          :min="0.0001"
          :step="0.1"
          :precision="4"
          placeholder="ROI系数不大于5，保留小数点后四位"
          :width="240"
        />
      </FormItem>
      <FormItem label="深度目标出价" v-if="data.deep_bid_type === 'DEEP_BID_MIN' && isShowBid">
        <input-number-plus
          v-model="data.deep_cpabid"
          :max="5"
          :maxNum="10000"
          :min="0.1"
          :step="0.1"
          :precision="2"
          placeholder="请输入0.1~10000的深度优化出价"
          :width="240"
        />
        <span style="padding-left: 8px">元</span>
      </FormItem>
    </Form>
    <Form v-else-if="type === 'landingPage' && data" inline :label-width="130" @submit.native.prevent>
      <FormItem label="落地页地址" style="margin-bottom: 10px">
        <Button icon="md-add" @click="addLandingPage" :disabled="data.web_url_material_list.length >= 10">添加落地页</Button>
        <span style="margin-left: 40px">{{ data.web_url_material_list.length }} / 10</span>
      </FormItem>
      <FormItem style="margin-bottom: 10px" v-for="(item, index) in data.web_url_material_list" :key="index">
        <Input v-model="data.web_url_material_list[index]" style="width: 450px" placeholder="请输入落地页链接" />
        <el-button type="primary" @click="selectPage(index)" style="margin-left: 10px">+选择</el-button>
        <Icon
          type="ios-trash-outline"
          size="22"
          color="#ff2200"
          v-if="data.web_url_material_list.length > 1"
          style="cursor: pointer; margin-left: 10px"
          @click="deleteLandingPage(index)"
        />
      </FormItem>
    </Form>
    <Form v-else-if="type === 'castTarget' && data" inline :label-width="140" @submit.native.prevent>
      <FormItem label="推广抖音号" style="margin-bottom: 0">
        <!-- <Select style="width:420px" placeholder="请选择推广抖音号" v-model="data.aweme_id" @on-change="awemeAccountChange" filterable>
          <Option v-for="item in [{name: '111',id: 1}]" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select> -->
        <el-select
          v-model="data.aweme_id"
          placeholder="请选择推广抖音号"
          style="width: 420px"
          :loading="loading"
          @on-change="awemeAccountChange"
          filterable
        >
          <el-option
            v-for="item in awemeAccountList"
            :key="item.aweme_id"
            :label="item.aweme_name"
            :value="item.aweme_id"
            style="width: 420px; height: 60px"
          >
            <img :src="item.aweme_avatar" width="40" style="float: left; margin-top: 10px; border-radius: 50px" />
            <div style="display: flex; flex-direction: column; margin-top: 8px">
              <span style="float: left; margin-left: 8px; color: black; line-height: 25px">{{ item.aweme_name }}</span>
              <span style="float: left; margin-left: 8px; color: rgb(126 126 126); line-height: 20px; font-size: 10px"
                >ID: {{ item.aweme_id }}</span
              >
            </div>
          </el-option>
        </el-select>
        <br />
        <Checkbox v-model="data.is_feed_and_fav_see">主页作品列表隐藏广告视频</Checkbox>
      </FormItem>
      <FormItem label="投放类型">
        <RadioGroup v-model="data.castType" type="button" @on-change="castTypeChange">
          <Radio label="LIVE">直播间转换</Radio>
          <Radio label="APP">应用推广</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="转化跟踪方式" v-if="data.castType === 'APP'">
        <RadioGroup v-model="data.convert_type" type="button" @on-change="covertTypeChange">
          <Radio label="AD_CONVERT_SOURCE_TYPE_SDK">应用下载SDK</Radio>
          <Radio label="AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD">应用下载API</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="优化目标" class="row-item-mus">
        <Select
          v-model="data.convert_id"
          style="width: 420px"
          :disabled="data.aweme_id === ''"
          :loading="loading"
          @on-change="opTargetsChange"
          filterable
        >
          <Option v-for="item in opTargets" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>
    </Form>
    <Form v-else-if="type === 'nativeAnchor' && data" inline :label-width="140" @submit.native.prevent>
      <FormItem label="原生锚点">
        <RadioGroup v-model="data.anchor_related_type" type="button">
          <Radio label="OFF">不启用</Radio>
          <Radio label="AUTO">自动生成</Radio>
          <Radio label="SELECT">手动生成</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="选择锚点" v-if="data.anchor_related_type === 'SELECT'">
        <AnchorSelect
          v-model="data.anchor_id"
          :anchor-name.sync="data.anchor_name"
          :account="data.accountId"
          :package-android="data.android_package_name"
          :package-ios="data.ios_package_name"
        ></AnchorSelect>
      </FormItem>
    </Form>
    <Form v-else-if="type === 'nativeSetting' && data" inline :label-width="140" @submit.native.prevent>
      <FormItem label="推广身份">
        <RadioGroup v-model="data.awemeIdentity" type="button">
          <Radio label="ACCOUNT">账户信息</Radio>
          <Radio label="AWEME">抖音号</Radio>
          <!-- 批量设置时禁用 -->
          <Radio label="AWEME_VIDEO" :disabled="data.batch" v-if="data.creative_mode === 2">抖音达人视频</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="抖音号" v-if="'AWEME' === data.awemeIdentity">
        <el-select
          v-model="data.aweme_id"
          placeholder="请选择推广抖音号"
          style="width: 420px"
          :loading="loading"
          :popper-append-to-body="false"
          filterable
        >
          <el-option
            v-for="item in awemeList"
            :key="item.aweme_id"
            :label="item.aweme_name"
            :value="item.aweme_id"
            style="width: 420px; height: 60px"
          >
            <img :src="item.aweme_avatar" width="40" style="float: left; margin-top: 10px; border-radius: 50px" />
            <div style="display: flex; flex-direction: column; margin-top: 8px">
              <span style="float: left; margin-left: 8px; color: black; line-height: 25px">{{ item.aweme_name }}</span>
              <span style="float: left; margin-left: 8px; color: rgb(126 126 126); line-height: 20px; font-size: 10px"
                >ID: {{ item.aweme_id }}</span
              >
            </div>
          </el-option>
        </el-select>
        <br />
        <Checkbox v-model="data.is_feed_and_fav_see" true-value="ON" false-value="OFF">主页作品列表隐藏广告视频</Checkbox>
      </FormItem>
      <FormItem label="达人选择" v-if="data.awemeIdentity === 'AWEME_VIDEO'">
        <!-- 目前只支持提交一个达人，所以切换达人后清空已选视频 -->
        <el-select
          v-model="data.aweme_video_user_id"
          @change="selectedAwemeVideos = []"
          :popper-append-to-body="false"
          placeholder="请选择达人"
          clearable
          filterable
        >
          <el-option v-for="item in uniqueAuthedAwemeList" :key="item.aweme_id" :label="item.aweme_name" :value="item.aweme_id"></el-option>
        </el-select>
      </FormItem>

      <FormItem label="视频选择" v-if="data.awemeIdentity === 'AWEME_VIDEO'">
        <div class="aweme-video-list" v-loading="loading">
          <div
            v-for="item in filteredAwemeVideoList"
            :key="item.aweme_id"
            class="aweme-video-item"
            :class="selectedAwemeVideos.map((i) => i.video_info.item_id).includes(item.video_info.item_id) ? 'active' : ''"
            @click="onAwemeVideoSelect(item)"
          >
            <em class="check-icon el-icon-circle-check"></em>
            <el-tag class="preview" @click="onAwemeVideoPreview(item)"> 预览</el-tag>
            <p class="desc">{{ item.video_info.title }}</p>
            <el-image class="aweme-video-cover" style="width: 165px" :src="item.video_info.video_cover_url" fit="contain"></el-image>
          </div>
        </div>
      </FormItem>
    </Form>
    <div v-else class="c-box">
      <Input v-model="keyword" search placeholder="请输入关键词" />
      <div class="c-content">
        <Row>
          <Col :span="colSpan">
            <div class="c-head">
              <span>{{ name }}列表 <ins v-if="type === 'pagespec'" style="font-size: 12px; color: #ff4400">仅支持穿山甲激励视频</ins></span>
              <span class="tag-title" v-show="type === 'retarget'">排除</span>
              <span class="tag-title" v-show="type === 'retarget'">定向</span>
              <span class="tag-title" v-show="type === 'retarget'">属性</span>
            </div>
            <div class="c-body">
              <div v-if="!drops.length" class="no-data">
                <Icon type="ios-filing-outline" size="58" color="#efefef" />
                <span>暂无数据</span>
              </div>
              <template v-else-if="type === 'retarget'">
                <div v-for="item in drops" :key="item.id" class="c-check-item g-clearfix">
                  <span class="m-span">{{ item.name }}</span>
                  <span class="item-type">{{ item.source === 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY' ? '第三方' : '自定义' }}</span>
                  <RadioGroup v-model="item.select" style="width: 64px; float: right; line-height: 36px">
                    <Radio label="include" style="margin-right: 8px"></Radio>
                    <Radio label="exclude" style="margin-right: 8px" :disabled="item.source === 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY'"></Radio>
                  </RadioGroup>
                  <span class="m-cataract c-include" @click.stop="changeRetarget(item, 'include')"></span>
                  <span v-if="item.source === 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY'" class="m-cataract c-exclude c-disabled"></span>
                  <span v-else class="m-cataract c-exclude" @click.stop="changeRetarget(item, 'exclude')"></span>
                </div>
              </template>
              <RadioGroup v-model="current" vertical v-else-if="type === 'target'" class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">{{ r.targetingName }}</Radio>
              </RadioGroup>
              <RadioGroup v-model="current" vertical v-else-if="type === 'creative'" class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">{{ r.campaign_name }}</Radio>
              </RadioGroup>
              <RadioGroup v-model="current" vertical v-else-if="type === 'pagespec'" class="c-item-radia-group" style="width: 100%">
                <template v-for="r in drops">
                  <Row :key="r.index">
                    <Col span="6"
                      ><Radio :label="r.index">{{ r.playable_name }}</Radio></Col
                    >
                    <Col span="18"
                      ><a :href="r.playable_url" target="_blank" rel="noopener noreferrer" class="c-item-radia-span">{{
                        r.playable_url
                      }}</a></Col
                    >
                  </Row>
                </template>
              </RadioGroup>
              <RadioGroup v-model="current" vertical v-else-if="type === 'convert'" class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">
                  {{ r.external_action | convType }}{{ r.deep_external_action | convDeepType }}
                  <!-- <span v-if="r.deep_external_action === 'AD_CONVERT_TYPE_PURCHASE_ROI'" style="color:#ff4400;margin-top:-15px;padding-left:22px;font-size:12px;display:block">
                    (白名单功能，未开通的账号请勿选择，否则会报错）
                  </span> -->
                </Radio>
              </RadioGroup>
              <RadioGroup v-model="current" vertical v-else class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">{{ r.name }}</Radio>
              </RadioGroup>
            </div>
          </Col>
          <Col span="8" v-if="type === 'retarget'">
            <div class="m-box c-result-box">
              <span class="c-retarget-clear" @click="$emit('on-clear', { type })">清空全部</span>
              <Tabs v-model="currenTab" size="small">
                <TabPane :label="`定向${includes.length ? '(' + includes.length + ')' : ''}`" class="c-retarget-result" name="include">
                  <div v-for="item in includes" :key="item.id" class="c-pop-tip">
                    <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
                  </div>
                </TabPane>
                <TabPane :label="`排除${excludes.length ? '(' + excludes.length + ')' : ''}`" class="c-retarget-result" name="exclude">
                  <div v-for="item in excludes" :key="item.id" class="c-pop-tip">
                    <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    <!-- 落地页弹框 -->
    <landpage v-model="linkModel" :default-game-id="gameId" NewTouTiaoPage @on-select="selectLinkLandPage"></landpage>

    <!-- 建站弹框 -->
    <page-data v-model="pageModal" :accounts="data.accounts" @on-select="selectAccount" @on-close="pageModal = false"> </page-data>

    <template slot="footer">
      <Button type="default" @click="$emit('input', false)">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { isArray, isEmpty, deepCopy, uniqueArray } from '@/common/js/utils'
import Landpage from '@/components/landpage/landpage.vue'
import InputNumberPlus from '@/components/input/input-number-plus'
import AnchorSelect from '@/components/anchor-select/anchor-select.vue'
import PageData from '@/components/page-select/page-data.vue'
import { iesAccountSearch, getAuthedAwemeList, getConvertListDeatil } from '@/api/toutiao.model'

const opTargetsLive = [
  { name: '直播间观看', id: 'AD_CONVERT_TYPE_LIVE_ENTER_ACTION' },
  { name: '直播间停留', id: 'AD_CONVERT_TYPE_LIVE_STAY_TIME' },
  { name: '直播间内打赏', id: 'AD_CONVERT_TYPE_LIVE_GIFT_ACTION' },
  { name: '账号关注', id: 'AD_CONVERT_TYPE_RSS' },
  { name: '组件点击', id: 'AD_CONVERT_TYPE_LIVE_COMPONENT_CLICK' },
  { name: '粉丝入群', id: 'AD_CONVERT_TYPE_LIVE_JOIN_GROUP' }
]
export default {
  name: 'setBatch',
  components: { InputNumberPlus, Landpage, AnchorSelect, PageData },
  props: {
    value: {
      type: Boolean
    },
    type: {
      type: String
    },
    gameId: {
      type: [String, Number]
    },
    data: {
      type: [Array, Object]
    },
    accountId: {
      type: Number
    },
    deliverRange: {
      type: String
    },
    bidType: {
      type: String
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    drops() {
      if (isArray(this.data)) {
        const drops = this.data
          .filter((ret) => {
            const keyword = String(this.keyword)
            if (keyword && this.type === 'target') return ret.targetingName.includes(keyword)
            else if (keyword && this.type === 'creative') return ret.campaign_name.includes(keyword)
            else if (keyword && this.type === 'pagespec') return ret.playable_name.includes(keyword)
            else if (keyword && this.type === 'convert') return true
            else if (keyword) return ret.name.includes(keyword)
            else {
              return true
            }
          })
          .map((met, i) => {
            return Object.assign(met, { index: i })
          })
        return drops
      } else return []
    },
    includes() {
      if (!isArray(this.drops)) return []
      return this.drops.filter((ret) => ret.select === 'include')
    },
    excludes() {
      if (!isArray(this.drops)) return []
      return this.drops.filter((ret) => ret.select === 'exclude')
    },
    title() {
      return `请选择${this.name}`
    },
    name() {
      let name = ''
      switch (this.type) {
        case 'account':
          name = '广告账号'
          break
        case 'campaign':
          name = '广告组'
          break
        case 'castTarget':
          name = '投放目标'
          break
        case 'nativeSetting':
          name = '推广身份'
          break
        case 'nativeAnchor':
          name = '原生锚点'
          break
        case 'target':
          name = '项目组合'
          break
        case 'retarget':
          name = '人群包'
          break
        case 'creative':
          name = '广告组'
          break
        case 'landingPage':
          name = '落地页'
          break
        case 'pagespec':
          name = '试玩素材'
          break
        case 'bid':
          name = '出价'
          break
      }
      return name
    },
    conversion() {
      return this.data.pricing === 'PRICING_OCPM'
    },
    smartConversion() {
      return this.data.smart_bid_type === 'SMART_BID_CONSERVATIVE'
    },
    showBid() {
      return (this.smartConversion && this.data.adjust_cpa) || !this.smartConversion
    },
    deepBid() {
      return this.data.deep_bid_type === 'DEEP_BID_MIN' || this.data.deep_bid_type === 'BID_PER_ACTION'
    },
    convertType() {
      return this.data.convert_type
    },
    castType() {
      return this.data.castType
    },
    opTargets() {
      if (this.data.castType === 'APP') {
        return this.data.convert_type === 'AD_CONVERT_SOURCE_TYPE_SDK' ? this.opTargets_SDK : this.opTargets_API
      } else return opTargetsLive
    },
    isShowBid() {
      return ['CUSTOM', 'UPPER_CONTROL'].includes(this.bidType)
    },
    /**
     * @description: 根据当前选中的抖音达人，显示对应的视频
     */
    filteredAwemeVideoList() {
      if (!this.data.aweme_video_user_id) return []
      return this.authedAwemeVideoList.filter((item) => item.aweme_id === this.data.aweme_video_user_id)
    }
  },
  data() {
    return {
      loading: null,
      keyword: '',
      current: '',
      currenTab: 'include',
      colSpan: 24,
      width: 620,
      linkModel: null,
      awemeList: [],
      awemeAccountList: [],
      opTargets_SDK: [],
      opTargets_API: [],
      pageModal: false,
      pageIndex: null,

      authedAwemeVideoList: [],
      uniqueAuthedAwemeList: [], // 去重后的authedAwemeList
      selectedAwemeVideos: []
    }
  },
  methods: {
    bindGetData(val) {
      if (this.type === 'retarget') {
        this.currenTab = 'include'
        this.colSpan = 16
        this.width = 820
      } else if (this.type === 'bid') {
        this.colSpan = 24
        this.width = 820
      } else {
        this.colSpan = 24
        this.width = 720
      }
      if (val) {
        this.keyword = ''
        if (this.type === 'budget') {
          const data = deepCopy(this.data)
          const { value } = data.pop()
          this.current = value || 0
        } else if (this.type === 'castTarget') {
          this.loading = true
          this.proGetConvertList()
        } else if (this.type === 'nativeSetting') {
          this.loading = true
          this.getAwemeList()
          this.getAuthedAwemeVideoList()

          const { awemeIdentity, aweme_video_list } = this.data

          if (awemeIdentity === 'AWEME_VIDEO') {
            this.selectedAwemeVideos = aweme_video_list || []
          }
        } else {
          this.current = ''
        }
      }
    },

    onAwemeVideoSelect(item) {
      const { video_info } = item
      const selected = this.selectedAwemeVideos.find((v) => v.video_info.item_id === video_info.item_id)
      if (selected) {
        this.selectedAwemeVideos = this.selectedAwemeVideos.filter((v) => v.video_info.item_id !== video_info.item_id)
      } else {
        this.selectedAwemeVideos.push(item)
      }
      this.$set(this.data, 'aweme_video_list', this.selectedAwemeVideos)
    },
    proGetConvertList() {
      Promise.all([
        iesAccountSearch({ ad_account_id: this.data.accountId }),
        getConvertListDeatil([{ ad_account_id: this.data.accountId, convert_source_type: 'AD_CONVERT_SOURCE_TYPE_SDK' }]),
        getConvertListDeatil([{ ad_account_id: this.data.accountId, convert_source_type: 'AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD' }])
      ])
        .then((data) => {
          this.loading = false
          if (isArray(data) && data.every((ret) => isArray(ret))) {
            const [awemeAccountList, opTargets_SDK, opTarget_API] = data
            this.awemeAccountList = awemeAccountList
            const opTSdk = opTargets_SDK.pop()
            const opTApi = opTarget_API.pop()
            if (opTSdk) {
              const { ad_convert_list } = opTSdk
              isArray(ad_convert_list) && (this.opTargets_SDK = ad_convert_list)
            }
            if (opTApi) {
              const { ad_convert_list } = opTApi
              isArray(ad_convert_list) && (this.opTargets_API = ad_convert_list)
            }
          } else {
            console.error('error！')
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    onAwemeVideoPreview(item) {
      window.open(item.video_info.aweme_play_url, '_blank')
    },
    getAuthedAwemeVideoList() {
      this.loading = true
      getAuthedAwemeList({ ad_account_id: this.data.accountId })
        .then((data) => {
          if (data?.length) {
            this.authedAwemeVideoList = data

            // 去重后的达人列表，用于达人下拉列表
            const uniqueAuthedAwemeList = uniqueArray(data, 'aweme_id')
            this.uniqueAuthedAwemeList = uniqueAuthedAwemeList
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getAwemeList() {
      iesAccountSearch({ ad_account_id: this.data.accountId })
        .then((data) => {
          this.loading = false
          if (data && isArray(data)) this.awemeList = data
        })
        .catch((err) => console.log(err))
    },
    // 选择落地页回调
    selectLinkLandPage(data) {
      this.data.page_id = data.land_page_id
      this.linkModel = false
    },
    awemeAccountChange(val) {
      this.data.aweme_id = val
    },
    castTypeChange(val) {
      this.data.castType = val
      this.data.external_action = undefined
    },
    covertTypeChange(val) {
      this.data.convert_type = val
      this.data.external_action = undefined
      this.data.opTargets = this.data.convert_type === 'AD_CONVERT_SOURCE_TYPE_SDK' ? this.data.opTargets_SDK : this.data.opTargets_API
    },
    opTargetsChange(val) {
      this.data.external_action = val
    },
    changeAdjustCpa(val) {
      this.data.cpa_bid = ''
      this.data.bid_range = 0
    },
    addLandingPage() {
      this.data.web_url_material_list.push('')
    },
    deleteLandingPage(index) {
      this.data.web_url_material_list.splice(index, 1)
    },
    changeDeepBid(val) {
      if (val === 'DEEP_BID_MIN' || val === 'BID_PER_ACTION') this.data.deep_cpabid = ''
      else this.data.deep_cpabid = undefined
    },
    changeBidRange(val) {
      if (val) {
        this.data.bid_num_range = ['', '']
        this.data.bid = ''
        this.data.cpa_bid = ''
      }
    },
    changeRetarget(item, type) {
      const check = item.select
      if (type === check) this.$set(item, 'select', null)
      else this.$set(item, 'select', type)
    },
    selectAccount(val) {
      const url = val[0].row.url
      this.data.web_url_material_list[this.pageIndex] = url
      this.pageModal = false
    },
    selectPage(index) {
      this.pageModal = true
      this.pageIndex = index
    },
    handleClose(e, name) {
      this.$emit('on-delete', { type: this.type, name })
    },
    ok() {
      const retarget = this.drops.some((ret) => {
        return ret.select === 'include' || ret.select === 'exclude'
      })
      if (this.type === 'retarget') {
        if (!retarget) {
          this.$Modal.confirm({
            title: '系统提示',
            content: `<p>您还未选择${this.name}，该操作将清除原已配置的人群包，确认该操作吗？</p>`,
            onOk: () => {
              this.submit(0)
            }
          })
        } else this.submit(0)
      } else if (this.type === 'bid') {
        const err = []
        // 出价设置
        const cpa_bid = this.data.cpa_bid
        if (this.isShowBid) {
          if (!(cpa_bid >= 0.1 && cpa_bid <= 10000)) err.push({ feild: '转化出价', msg: '出价范围：0.1~10000（元）' })
          if (cpa_bid > this.data.budget) err.push({ feild: '转化出价', msg: '不能大于预算值' })
          if (this.data.deep_bid_type === 'ROI_COEFFICIENT') {
            // ROI校验
            if (isEmpty(this.data.roi_goal)) err.push({ feild: 'ROI系数', msg: 'ROI系数不能为空' })
            else {
              const roi = Number(this.data.roi_goal)
              const min = 0
              const max = 5
              if (roi <= min || roi > max) err.push({ feild: 'ROI系数', msg: `ROI系数应大于${min}，小于等于${max}` })
            }
          } else if (this.data.deep_bid_type === 'DEEP_BID_MIN') {
            // 双出价校验
            if (isEmpty(this.data.deep_cpabid)) err.push({ feild: '深度目标出价', msg: '不能为空' })
          }
        }

        if (err.length) {
          const shift = err.shift()
          this.$Message.error(`${shift.feild}${shift.msg}`)
          // 如果错误中断
          return
        }
        this.submit(this.data)
      } else if (this.type === 'castTarget') {
        if (this.data.castType === 'APP') {
          this.data.convert_id = this.data.external_action
          delete this.data.external_action
        }
        this.submit(this.data)
      } else if (this.type === 'landingPage') {
        if (this.data.web_url_material_list.some((ret) => isEmpty(ret))) this.$Message.error('落地页链接不能为空！')
        else this.submit(this.data)
      } else if (this.type === 'nativeSetting') {
        if (this.data.awemeIdentity === 'ACCOUNT') this.data.aweme_id = ''
        if (this.data.awemeIdentity === 'AWEME' && !this.data.aweme_id) this.$Message.error('请选择推广抖音号！')
        if (this.data.awemeIdentity === 'AWEME_VIDEO' && !this.data.aweme_video_list?.length) this.$Message.error('请选择达人视频号！')
        else {
          this.submit(this.data)
          this.selectedAwemeVideos = []
        }
      } else if (this.type === 'nativeAnchor') {
        if (this.data.anchor_related_type === 'SELECT' && !this.data.anchor_id) this.$Message.error('请选择原生锚点！')
        else this.submit(this.data)
      } else if (this.type === 'budget') {
        if (!this.current || this.current < 300 || this.current > 9999999.99) {
          this.$Message.error('预算不能为空，且出价范围需在300-9999999.99元之间')
          return
        }
        this.submit(this.current)
      } else {
        if (typeof this.current !== 'number' && this.type !== 'pagespec') {
          this.$Message.error(`您还未选择${this.name}`)
          return
        }
        this.submit(this.current)
      }
    },
    submit(index) {
      this.$emit('on-select', { type: this.type, index })
      this.$emit('input', false)
    }
  },
  filters: {
    sourceType(cell) {
      return cell === 'AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD' ? '应用下载API' : '应用下载SDK'
    },
    convType(cell) {
      if (cell === 'AD_CONVERT_TYPE_ACTIVE') return '激活'
      else if (cell === 'AD_CONVERT_TYPE_PAY') return '付费'
      else if (cell === 'AD_CONVERT_TYPE_ACTIVE_REGISTER') return '注册'
      else if (cell === 'AD_CONVERT_TYPE_GAME_ADDICTION') return '关键行为'
      else if (cell === 'AD_CONVERT_TYPE_DOWNLOAD_START') return '完成下载'
      else if (cell === 'AD_CONVERT_TYPE_FORM') return '表单提交'
      else if (cell === 'AD_CONVERT_TYPE_WECHAT_WECOM_ADD') return '微信_添加企业微信'
      else if (cell === 'AD_CONVERT_TYPE_WECHAT_PAY') return '微信内付费'
      else if (cell === 'AD_CONVERT_TYPE_NOTIFY_FORM') return '预约表单'
      else if (cell === 'AD_CONVERT_TYPE_NOTIFY_DOWNLOAD') return '预约下载'
    },
    convDeepType(cell) {
      if (cell === 'AD_CONVERT_TYPE_ACTIVE_REGISTER') return '，深度转化，注册'
      else if (cell === 'AD_CONVERT_TYPE_PAY') return '，深度转化，付费'
      else if (cell === 'AD_CONVERT_TYPE_NEXT_DAY_OPEN') return '，深度转化，次留'
      else if (cell === 'AD_CONVERT_TYPE_PURCHASE_ROI') return '，深度转化，付费ROI'
      else if (cell === 'AD_CONVERT_TYPE_CLUE_CONFIRM') return '，深度转化，回访_信息确认'
      else if (cell === 'AD_CONVERT_TYPE_CLUE_INTERFLOW') return '，深度转化，回访_加为好友'
      else if (cell === 'AD_CONVERT_TYPE_CLUE_HIGH_INTENTION') return '，深度转化，回访_高潜成交'
      else return ''
    }
  }
}
</script>
<style lang='scss' scoped>
.c-box {
  position: relative;

  .c-content {
    margin-top: 12px;
    border: solid 1px #dee4f5;
    border-radius: 3px;
    font-size: 14px;

    .c-head {
      line-height: 32px;
      background-color: #fafbfe;
      padding-left: 12px;
      border-bottom: solid 1px #dee4f5;

      span.tag-title {
        float: right;
        font-size: 12px;
        margin-right: 14px;
      }
    }

    .c-body {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      max-height: 365px;
      min-height: 120px;

      .ivu-radio-wrapper {
        font-size: 13px;

        ::v-deep .ivu-radio {
          margin-right: 8px;
        }
      }

      .no-data {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        span {
          color: #c1c1c1;
        }
      }

      .c-item-radia-group {
        padding: 8px 0 8px 12px;
      }

      .c-item-radia-span {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        width: 100%;
        display: inline-block;
        line-height: 30px;
      }

      .c-check-item {
        margin: 0;
        padding-left: 12px;
        display: flex;
        position: relative;
        align-items: center;
        height: 36px;
        width: 100%;

        &:hover {
          background-color: #f8f8f8;
        }

        .m-span {
          width: calc(100% - 112px);
          display: inline-block;
        }

        .item-type {
          display: inline-block;
          font-size: 12px;
          width: 56px;
        }

        .ivu-radio-wrapper {
          min-width: inherit;
          text-align: right;
          font-size: 0;
          margin-right: 14px;
        }

        .m-cataract {
          position: absolute;
          width: 18px;
          height: 36px;
          cursor: pointer;
          user-select: none;
          top: 0;

          &.c-disabled {
            cursor: not-allowed;
          }
        }

        .c-include {
          right: 46px;
        }

        .c-exclude {
          right: 16px;
        }
      }
    }

    .c-result-box {
      position: relative;

      ::v-deep.ivu-tabs-bar {
        background-color: #fafbfe;
        margin-bottom: 0;
      }

      .c-retarget-clear {
        width: 60px;
        height: 34px;
        line-height: 34px;
        position: absolute;
        z-index: 8;
        right: 0;
        top: 0;
        display: block;
        color: #598fe6;
        text-align: center;
        cursor: pointer;
        font-size: 12px;
      }

      .c-retarget-result {
        overflow-y: auto;
        scrollbar-width: thin;
        -webkit-overflow-scrolling: touch;
        height: 365px;
        padding-bottom: 8px;

        .c-tag-item {
          margin: 8px 12px 0;
          padding: 2px 6px;
          display: block;
          height: 28px;

          ::v-deep .ivu-tag-text {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: 88%;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

.aweme-video-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  height: 300px;
  max-height: 420px;
  overflow-y: auto;

  .aweme-video-item {
    border: 2px solid transparent;
    border-radius: 2px;
    position: relative;
    height: 293px;
    overflow: hidden;

    &.active {
      border: 2px solid #1974ff;

      .check-icon {
        color: #1974ff;
        font-weight: 700;
      }
    }

    .preview {
      position: absolute;
      left: 10px;
      top: 10px;
      z-index: 1;
      cursor: pointer;
    }

    .check-icon {
      color: transparent;
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 20px;
      z-index: 1;
    }

    .desc {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 1;
      line-height: 14px;
      font-size: 12px;
      color: #fff;
      padding: 5px;
      background: rgba(0, 0, 0, 0.5);
    }

    .aweme-video-cover {
      cursor: pointer;
    }
  }
}

.ivu-form-inline .ivu-form-item {
  display: block;
}

// ::v-deep .el-select-dropdown__item {
//   height: 100px;
// }
</style>
